import {
	BodyL,
	FlowPage,
	useAnnouncementOfElement,
} from '@monthio/design-system'
import { LoadingSpinner } from '@monthio/react-components'
import { useEndOfFlowCountdownAction } from '#hooks'
import { flowFinishedCleanUp } from '#hooks/useFlowCleanupOnLeave'
import { Trans, useTranslation } from 'react-i18next'

import {
	FlowRedirectConfirmDescription,
	FlowRedirectConfirmRedirectionURL,
} from '../FlowCompletedScreen.styled'

const clearUserConsentAndCloseOrRedirect = (redirectUrl?: string) => {
	flowFinishedCleanUp()
	if (redirectUrl) {
		window.location.href = redirectUrl
	} else {
		window.close()
	}
}

const textId = 'end-of-flow-notice-text'

export const EndOfFlowNotice = ({
	redirectUrl,
	redirectUrlNoQueryParams,
	shouldRedirectWithoutDelay = false,
	shouldAutoCloseTabWithoutDelay = false,
}: {
	redirectUrl?: string
	redirectUrlNoQueryParams?: string | null
	shouldRedirectWithoutDelay?: boolean
	shouldAutoCloseTabWithoutDelay?: boolean
}) => {
	const { t } = useTranslation()

	const countStart = 10
	const count = useEndOfFlowCountdownAction({
		durationSeconds: countStart,
		redirectUrl,
		clearUserConsentAndCloseOrRedirect,
	})

	useAnnouncementOfElement(textId)

	if (redirectUrl != null && shouldRedirectWithoutDelay) {
		window.location.href = redirectUrl
		return null
	} else if (shouldAutoCloseTabWithoutDelay) {
		window.close()
		return null
	}

	return (
		<FlowPage>
			<FlowPage.Content $isCentered $spacing="xs">
				<FlowRedirectConfirmDescription>
					<article id={textId}>
						<FlowPage.Header
							title={
								redirectUrl != null
									? t('flowCompletedScreen-redirect-notice-title')
									: t('flowCompletedScreen-closeTab-notice-title')
							}
							noAnnouncement
						/>
						<BodyL>
							{count < 0 && redirectUrl != null ? (
								<>
									<BodyL>
										{t('flowCompletedScreen-redirect-notice-redirecting')}
									</BodyL>
									<LoadingSpinner />
								</>
							) : count < 0 ? (
								<Trans
									i18nKey={
										'flowCompletedScreen-error-occurred-please-close-tab-manually'
									}
								/>
							) : (
								<Trans
									i18nKey={
										redirectUrl != null
											? 'flowCompletedScreen-redirect-notice-text'
											: 'flowCompletedScreen-closeTab-notice-text'
									}
									values={{
										count,
										redirectUrl: redirectUrlNoQueryParams,
									}}
									components={{
										count: <></>,
										redirectUrl:
											redirectUrl != null ? (
												<FlowRedirectConfirmRedirectionURL />
											) : (
												<></>
											),
									}}
								/>
							)}
						</BodyL>
					</article>
				</FlowRedirectConfirmDescription>
			</FlowPage.Content>
			<FlowPage.Footer
				actions={
					<FlowPage.Cta
						width="full-width"
						onClick={() => {
							clearUserConsentAndCloseOrRedirect(redirectUrl)
						}}
					>
						{redirectUrl != null
							? t('flowCompletedScreen-redirect-notice-redirect-now-btn')
							: t('flowCompletedScreen-closeTab-notice-closeTab-now-btn')}
					</FlowPage.Cta>
				}
			/>
		</FlowPage>
	)
}
